import * as Sentry from "@sentry/browser";

const environment = document.querySelector('meta[name="environment"]')?.content || 'development';

const dsn = ['production', 'staging'].includes(environment)
  ? "https://e85f0b67473c3b903d1d1c2c5544df48@o1139896.ingest.sentry.io/4506191764586496"
  : "";

Sentry.init({
  dsn,
  environment,
  sampleRate: 1.0,
  tracesSampleRate: 0,
  autoSessionTracking: true,
  ignoreErrors: [
    'Fetch is aborted',
    'Load failed'
  ]
});

window.Sentry = Sentry;
